module.exports = __webpack_public_path__ + "img/SES_4100063395.2d2d2053.jpg";